const SCHOOL_COLOR_MAP = {
  blue: 'blue.500',
  purple: 'purple.500',
  cyan: 'cyan.700',
  orange: 'orange.700',
} as const;

export type SchoolListEntry = {
  slug: string;
  color: string;
  iconPath: string;
};

/**
 * Display order is intentional — the school grids render entries as-is.
 * Localized names come from `getSchoolShortName`, so no copy lives here.
 */
export const SCHOOLS: SchoolListEntry[] = (
  [
    {
      slug: 'artificial-intelligence',
      color: 'blue',
      iconPath: '/images/school-icons/shields/artificial-intelligence.svg',
    },
    {
      slug: 'data-science',
      color: 'blue',
      iconPath: '/images/school-icons/shields/data-science.svg',
    },
    {
      slug: 'business',
      color: 'purple',
      iconPath: '/images/school-icons/shields/business.svg',
    },
    {
      slug: 'executive-leadership',
      color: 'purple',
      iconPath: '/images/school-icons/shields/executive-leadership.svg',
    },
    {
      slug: 'programming',
      color: 'cyan',
      iconPath: '/images/school-icons/shields/programming.svg',
    },
    {
      slug: 'cloud-computing',
      color: 'cyan',
      iconPath: '/images/school-icons/shields/cloud-computing.svg',
    },
    {
      slug: 'autonomous-systems',
      color: 'orange',
      iconPath: '/images/school-icons/shields/autonomous-systems.svg',
    },
    {
      slug: 'cybersecurity',
      color: 'orange',
      iconPath: '/images/school-icons/shields/cybersecurity.svg',
    },
    {
      slug: 'product-management',
      color: 'purple',
      iconPath: '/images/school-icons/shields/product-management.svg',
    },
    {
      slug: 'career-resources',
      color: 'purple',
      iconPath: '/images/school-icons/shields/career-resources.svg',
    },
    {
      slug: 'animation-and-game-development',
      color: 'orange',
      iconPath: '/images/school-icons/shields/animation-and-game-dev.svg',
    },
    {
      slug: 'devops',
      color: 'cyan',
      iconPath: '/images/school-icons/shields/devops.svg',
    },
  ] as const
).map((school) => ({
  ...school,
  color: SCHOOL_COLOR_MAP[school.color],
}));
